import { getHeaders } from './tokenUtil';
class LowPriceNotifierService {
  constructor(baseUrl) {
    this.baseUrl = baseUrl;
  }

  async addHotel(request) {
    const response = await fetch(`${this.baseUrl}/api/LowPriceNotifier/addhotel`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(request)
    });
    return response.json();
  }

  async removeHotel(request) {
    const url = new URL(`${this.baseUrl}/api/LowPriceNotifier/removehotel`);
    Object.keys(request).forEach(key => url.searchParams.append(key, request[key]));

    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    });
    return response.json();
  }

  async getHotelsByUser(request) {
    const url = new URL(`${this.baseUrl}/api/LowPriceNotifier/gethotelsbyuser`);
    Object.keys(request).forEach(key => url.searchParams.append(key, request[key]));

    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    });
    return response.json();
  }

  async getHotelsByUserFacade(request) {
    const url = new URL(`${this.baseUrl}/api/Favorites/get`);
    Object.keys(request).forEach(key => url.searchParams.append(key, request[key]));

    const response = await fetch(url, {
      method: 'GET',
      headers: {
       'Content-Type': 'application/json',
      ...getHeaders() 
      }
    });
    return response.json();
  }

  async copyByUser(request) {
    const url = new URL(`${this.baseUrl}/api/LowPriceNotifier/copyByUser`);
    Object.keys(request).forEach(key => url.searchParams.append(key, request[key]));

    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    });
    return response.json();
  }
}

export default LowPriceNotifierService;
